import React from 'react'

function Phone(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0.02 23.95 23.9"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M23.41 18.93l-3.7-3.7a1.93 1.93 0 00-2.72.05l-1.86 1.86-.37-.2a18.56 18.56 0 01-4.48-3.24c-1.7-1.7-2.6-3.32-3.25-4.5l-.2-.35L8.08 7.6l.62-.62c.76-.76.78-1.98.05-2.72L5.05.56a1.93 1.93 0 00-2.72.05L1.29 1.66l.03.03A6 6 0 00.07 4.74c-.48 4.05 1.37 7.75 6.39 12.77 6.94 6.94 12.53 6.42 12.77 6.4a6.27 6.27 0 003.05-1.25l.02.02 1.06-1.03c.76-.76.79-1.98.05-2.72z"
            />
        </svg>
    )
}

export default Phone
